





















































































































































import { Component, Vue } from "vue-property-decorator";
import { storeKepatuhanVisiteDpjp } from "@/store/modules/KepatuhanVisiteDpjpStore";
import Service from "@/services/KepatuhanVisiteDpjpService";
import KepatuhanVisiteDpjpForm from "./KepatuhanVisiteDpjpForm.vue";

@Component({
  components: { KepatuhanVisiteDpjpForm }
})
export default class KepatuhanVisiteDpjpList extends Vue {
  storeModule = storeKepatuhanVisiteDpjp;

  showForm = false;
  editData: any = null;

  filterBulan: number = new Date().getMonth() + 1;
  filterTahun: number = new Date().getFullYear();
  filterStatus: string | null = null;
  filterTanggal: string | null = null;

  showDeleteDialog = false;
  deleteTarget: any = null;

  headers = [
    { text: "Tanggal", value: "tanggal_observasi", width: "100px" },
    { text: "No Formulir", value: "nomor_formulir", width: "150px" },
    { text: "Unit", value: "unit_ruang_rawat_nama" },
    { text: "Dokter Spesialis", value: "nama_dokter_spesialis" },
    { text: "Obs", value: "jumlah_diobservasi", width: "50px", align: "center" },
    { text: "Capaian", value: "capaian_persen", width: "90px", align: "center" },
    { text: "Status", value: "status", width: "90px", align: "center" },
    { text: "Aksi", value: "actions", sortable: false, width: "110px", align: "center" },
  ];

  bulanOptions = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 },
  ];

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "Submitted", value: "submitted" },
    { text: "Verified", value: "verified" },
    { text: "Approved", value: "approved" },
  ];

  mounted() {
    this.loadData();
    // Restore active session dari URL query
    const qsId = this.$route.query.session_id;
    if (qsId) {
      this.editData = { id: Number(qsId) };
      this.showForm = true;
    }
  }

  async loadData() {
    const params: any = {};
    if (this.filterBulan) params.bulan = this.filterBulan;
    if (this.filterTahun) params.tahun = this.filterTahun;
    if (this.filterStatus) params.status = this.filterStatus;
    if (this.filterTanggal) params.tanggal = this.filterTanggal;
    await this.storeModule.loadSessions(params);
  }

  updateUrlQuery(sessionId: number | null) {
    const query = sessionId ? { session_id: String(sessionId) } : {};
    this.$router.replace({ query }).catch(() => {});
  }

  tambahBaru() {
    this.editData = null;
    this.showForm = true;
    this.updateUrlQuery(null);
  }

  lihat(item: any) {
    this.editData = item;
    this.showForm = true;
    this.updateUrlQuery(item.id);
  }

  cetak(item: any) {
    const url = Service.getPdfUrl(item.id);
    window.open(url, "_blank");
  }

  hapus(item: any) {
    this.deleteTarget = item;
    this.showDeleteDialog = true;
  }

  async confirmDelete() {
    if (!this.deleteTarget) return;
    try {
      await Service.deleteSession(this.deleteTarget.id);
      this.showDeleteDialog = false;
      this.deleteTarget = null;
      await this.loadData();
    } catch (e) {
      // Error handled by service
    }
  }

  onBack() {
    this.showForm = false;
    this.editData = null;
    this.updateUrlQuery(null);
    this.loadData();
  }

  onSaved() {
    this.showForm = false;
    this.editData = null;
    this.updateUrlQuery(null);
    this.loadData();
  }

  formatDate(val: string): string {
    if (!val) return "-";
    const d = new Date(val);
    return d.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }

  statusColor(status: string): string {
    const map: any = {
      draft: "grey",
      submitted: "blue",
      verified: "orange",
      approved: "green",
      closed: "purple"
    };
    return map[status] || "grey";
  }
}
